const initialState = {
	isCheckingForImages: false,
	byAsset: {},
	imageFlags: {}
};

export default initialState;
